export default __webpack_public_path__ + "static/media/flores-benefits-mastercard.c6a7b9e8.svg";